/* Estelle's Closet — Find My Size */
(function () {
  'use strict';

  var STORAGE_KEY = 'ec_fms_profile_v1';
  var TOTAL_STEPS = 4;

  // US women's size chart — center-of-bracket weight (lbs) at average 5'6" frame
  // Used as a scoring anchor; we score each size by distance from the user's point
  // in (weight, bust/hip shape) space, then pick the best match from what the product sells.
  var SIZE_TABLE = [
    { size: '0',  letter: 'XS', weightCenter: 108 },
    { size: '2',  letter: 'XS', weightCenter: 118 },
    { size: '4',  letter: 'S',  weightCenter: 128 },
    { size: '6',  letter: 'S',  weightCenter: 138 },
    { size: '8',  letter: 'M',  weightCenter: 148 },
    { size: '10', letter: 'M',  weightCenter: 160 },
    { size: '12', letter: 'L',  weightCenter: 172 },
    { size: '14', letter: 'L',  weightCenter: 186 },
    { size: '16', letter: 'XL', weightCenter: 200 },
    { size: '18', letter: 'XL', weightCenter: 216 },
    { size: '20', letter: 'XXL', weightCenter: 232 }
  ];

  function normalizeSizeLabel(raw) {
    if (!raw) return '';
    return String(raw).trim().toUpperCase().replace(/\s+/g, '');
  }

  // Parse a range cell like "31.4-33" or "33" into { min, max }
  function parseRange(cell) {
    if (cell == null) return null;
    var s = String(cell).replace(/[^\d.\-–—]/g, '').replace(/[–—]/g, '-');
    var parts = s.split('-').filter(function (p) { return p.length > 0; });
    var nums = parts.map(parseFloat).filter(function (n) { return !isNaN(n); });
    if (nums.length === 0) return null;
    if (nums.length === 1) return { min: nums[0], max: nums[0] };
    return { min: Math.min(nums[0], nums[1]), max: Math.max(nums[0], nums[1]) };
  }

  // Try to read Relentless app's per-product size chart from the storefront.
  // Returns an array of { labels: [..], bust, waist, hips } rows, or null.
  function readRelentlessChart() {
    try {
      var r = window.sizeChartsRelentless;
      var chart = r && r.metafield && (r.metafield.chart || (r.metafield.charts && r.metafield.charts[0]));
      if (!chart || !chart.values || !chart.values.length) return null;

      var header = chart.values[0].map(function (h) { return String(h || '').toLowerCase(); });
      var colBust  = header.findIndex(function (h) { return h.indexOf('bust') !== -1; });
      var colWaist = header.findIndex(function (h) { return h.indexOf('waist') !== -1; });
      var colHips  = header.findIndex(function (h) { return h.indexOf('hip') !== -1; });
      if (colBust === -1 && colWaist === -1 && colHips === -1) return null;

      // Label columns = everything that isn't a measurement column
      var labelCols = header.map(function (_, i) { return i; })
        .filter(function (i) { return i !== colBust && i !== colWaist && i !== colHips; });

      var rows = [];
      for (var r2 = 1; r2 < chart.values.length; r2++) {
        var row = chart.values[r2];
        rows.push({
          labels: labelCols.map(function (i) { return row[i]; }).filter(Boolean),
          bust:  colBust  !== -1 ? parseRange(row[colBust])  : null,
          waist: colWaist !== -1 ? parseRange(row[colWaist]) : null,
          hips:  colHips  !== -1 ? parseRange(row[colHips])  : null
        });
      }
      return rows.length ? rows : null;
    } catch (e) {
      return null;
    }
  }

  // Estimate user body measurements (inches) from height/weight + shape.
  // Baseline anchor: 5'6" (66 in) / 140 lbs ≈ bust 35, waist 28, hips 38 (average US size 6).
  function estimateMeasurements(inputs) {
    var heightIn = (inputs.ft || 0) * 12 + (inputs.in || 0);
    var weight = inputs.lbs || 0;
    if (!heightIn || !weight) return null;

    var dW = weight - 140;    // delta from baseline weight
    var dH = heightIn - 66;   // delta from baseline height

    // Per 10 lbs: bust +0.7", waist +0.9", hips +0.7"
    // Per 2 in height: all +0.3" (taller frames are slightly larger)
    var bust  = 35 + (dW / 10) * 0.7 + (dH / 2) * 0.3;
    var waist = 28 + (dW / 10) * 0.9 + (dH / 2) * 0.3;
    var hips  = 38 + (dW / 10) * 0.7 + (dH / 2) * 0.3;

    // Shape adjustments
    if (inputs.bust === 'full')    bust += 1.5;
    if (inputs.bust === 'small')   bust -= 1;
    if (inputs.belly === 'curvy')  waist += 1.5;
    if (inputs.belly === 'flat')   waist -= 1;
    if (inputs.hips === 'wide')    hips += 1.5;
    if (inputs.hips === 'narrow')  hips -= 1;

    return { bust: bust, waist: waist, hips: hips };
  }

  // Score a chart row vs estimated measurements — lower is better.
  // Inside the range: 0. Outside: distance in inches (squared, weighted).
  function scoreChartRow(row, m, fitPref) {
    var weights = { bust: 1.3, waist: 1.5, hips: 1.0 };
    var total = 0, count = 0;
    ['bust', 'waist', 'hips'].forEach(function (k) {
      if (!row[k] || m[k] == null) return;
      var lo = row[k].min, hi = row[k].max;
      // Apply fit preference: fitted => prefer ranges that sit just below user; relaxed => above
      var user = m[k] + (fitPref || 0) * 0.5;
      var dist = user < lo ? (lo - user) : (user > hi ? (user - hi) : 0);
      total += weights[k] * dist * dist;
      count++;
    });
    return count ? total : Infinity;
  }

  function recommendSizeFromChart(inputs, productSizes, chartRows) {
    var m = estimateMeasurements(inputs);
    if (!m) return null;

    var productNorm = productSizes.map(normalizeSizeLabel);
    var scored = chartRows.map(function (row) {
      // Pick the label from this row that is actually sold by the product
      var matchLabel = null;
      for (var i = 0; i < row.labels.length; i++) {
        var n = normalizeSizeLabel(row.labels[i]);
        var idx = productNorm.indexOf(n);
        if (idx !== -1) { matchLabel = productSizes[idx]; break; }
      }
      return { row: row, matchLabel: matchLabel, score: scoreChartRow(row, m, inputs.fit || 0) };
    });

    // Only consider rows the product actually sells
    var sellable = scored.filter(function (s) { return s.matchLabel; });
    if (!sellable.length) return null;

    sellable.sort(function (a, b) { return a.score - b.score; });
    var best = sellable[0];
    var runnerUp = sellable[1] ? sellable[1].score : best.score + 20;
    var gap = Math.max(0, runnerUp - best.score);

    // Confidence: perfect-fit (score 0) → high base; larger runner-up gap → higher
    var base = best.score < 0.5 ? 90 : best.score < 3 ? 80 : best.score < 8 ? 70 : 60;
    var confidence = Math.round(base + Math.min(8, gap / 2));
    confidence = Math.max(55, Math.min(95, confidence));

    return { size: best.matchLabel, confidence: confidence, measurements: m };
  }

  // Build a scoring function: lower score = better fit
  function scoreSize(entry, ctx) {
    var diff = Math.abs(entry.weightCenter - ctx.adjustedWeight);
    // penalty grows quadratically so closer matches dominate
    return diff * diff;
  }

  function recommendSize(inputs, productSizes) {
    // Prefer the product's real size chart if we can read it
    var chartRows = readRelentlessChart();
    if (chartRows) {
      var viaChart = recommendSizeFromChart(inputs, productSizes, chartRows);
      if (viaChart) return viaChart;
    }
    return recommendSizeHeuristic(inputs, productSizes);
  }

  function recommendSizeHeuristic(inputs, productSizes) {
    var heightIn = (inputs.ft || 0) * 12 + (inputs.in || 0);
    var weight = inputs.lbs || 0;
    if (!heightIn || !weight) return null;

    // Normalize weight for frame: taller => weight spreads out (smaller size at same lbs)
    var frameAdjust = (heightIn - 66) * 2.2; // 5'6" baseline; every inch ≈ 2.2 lbs
    var adjustedWeight = weight - frameAdjust;

    // Body shape adjustments (curvier adds ~one bracket worth of weight)
    var shapeBonus = 0;
    if (inputs.belly === 'curvy')   shapeBonus += 8;
    if (inputs.belly === 'flat')    shapeBonus -= 4;
    if (inputs.hips === 'wide')     shapeBonus += 8;
    if (inputs.hips === 'narrow')   shapeBonus -= 4;
    if (inputs.bust === 'full')     shapeBonus += 6;
    if (inputs.bust === 'small')    shapeBonus -= 3;
    adjustedWeight += shapeBonus;

    // Fit preference: -1 fitted (size down), 0 true, +1 relaxed (size up)
    adjustedWeight += (inputs.fit || 0) * 10;

    var ctx = { adjustedWeight: adjustedWeight };

    // Score every size in the table
    var scored = SIZE_TABLE.map(function (e) {
      return { entry: e, score: scoreSize(e, ctx) };
    });
    scored.sort(function (a, b) { return a.score - b.score; });

    // Find the best match that the product actually sells
    var match = null;
    var productNormalized = productSizes.map(function (s) {
      return { raw: s, norm: normalizeSizeLabel(s) };
    });

    for (var i = 0; i < scored.length; i++) {
      var entry = scored[i].entry;
      var target = [normalizeSizeLabel(entry.size), normalizeSizeLabel(entry.letter)];
      for (var j = 0; j < productNormalized.length; j++) {
        if (target.indexOf(productNormalized[j].norm) !== -1) {
          match = { size: productNormalized[j].raw, baseScore: scored[i].score, idx: i };
          break;
        }
      }
      if (match) break;
    }

    if (!match) {
      // product sizes don't match US numeric or letter; fall back to middle-of-list variant
      match = { size: productSizes[Math.floor(productSizes.length / 2)], baseScore: scored[0].score, idx: 0 };
    }

    // Confidence: top score in tight range = high; falls off quickly
    // Convert score (squared lbs) into a soft confidence percentage.
    var runnerUp = scored[1] ? scored[1].score : match.baseScore + 200;
    var gap = Math.max(0, runnerUp - match.baseScore);
    var confidence = Math.round(65 + Math.min(30, gap / 10));
    if (match.idx > 0) confidence -= 5; // penalty if we had to walk down the list
    confidence = Math.max(55, Math.min(94, confidence));

    return { size: match.size, confidence: confidence };
  }

  function loadProfile() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }
  function saveProfile(profile) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(profile)); } catch (e) {}
  }

  function findSizePillsHost() {
    // Prefer the explicit data attribute if present
    var byData = document.querySelector('.variant-options-container[data-option-name="Size" i], .variant-options-container[data-option-name="Maat" i]');
    if (byData && byData.parentElement) return { pills: byData, host: byData.parentElement };

    // Otherwise infer from labels
    var inputs = document.querySelectorAll('.product-form__input--pills, .product-form__input');
    for (var i = 0; i < inputs.length; i++) {
      var label = inputs[i].querySelector('.form__label');
      if (!label || !/size|maat/i.test(label.textContent || '')) continue;
      var pills = inputs[i].querySelector('.variant-options-container') || inputs[i];
      return { pills: pills, host: inputs[i] };
    }
    return null;
  }

  function placeTrigger() {
    var trigger = document.querySelector('.ec-fms__trigger');
    if (!trigger) return;

    var found = findSizePillsHost();
    if (!found) return;

    var labelContainer = found.host.querySelector('.product-form__label-container');
    if (!labelContainer) return;

    // Clean up legacy desktop host layout if it was applied previously
    document.querySelectorAll('.ec-fms__pills-host').forEach(function (el) {
      el.classList.remove('ec-fms__pills-host');
    });

    labelContainer.classList.add('ec-fms__label-host');
    if (trigger.parentElement !== labelContainer) {
      labelContainer.appendChild(trigger);
    }
  }

  function initModal(modal) {
    var openBtns = document.querySelectorAll('[data-ec-fms-open]');
    var sizes = [];
    try { sizes = JSON.parse(modal.getAttribute('data-ec-fms-sizes') || '[]'); } catch (e) { sizes = []; }
    var optionIndex = parseInt(modal.getAttribute('data-ec-fms-option-index'), 10);
    var productFormId = modal.getAttribute('data-ec-fms-form-id');

    var dialog = modal.querySelector('.ec-fms__dialog');
    var titleEl = modal.querySelector('[data-ec-fms-title]');
    var progressEls = modal.querySelectorAll('[data-ec-fms-progress] span');
    var steps = modal.querySelectorAll('[data-ec-fms-step]');
    var backBtn = modal.querySelector('[data-ec-fms-back]');
    var nextBtn = modal.querySelector('[data-ec-fms-next]');
    var ctaBtn = modal.querySelector('[data-ec-fms-select]');

    var inputs = {
      ft: null, in: null, lbs: null,
      belly: 'average', hips: 'average', bust: 'average',
      fit: 0
    };

    var saved = loadProfile();
    if (saved) {
      inputs.ft = saved.ft; inputs.in = saved.in; inputs.lbs = saved.lbs;
      inputs.belly = saved.belly || 'average';
      inputs.hips = saved.hips || 'average';
      inputs.bust = saved.bust || 'average';
      inputs.fit = saved.fit || 0;
    }

    var state = { step: 1, result: null };

    // Wire open/close
    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { open(); });
    });
    modal.querySelectorAll('[data-ec-fms-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (!modal.hasAttribute('hidden') && e.key === 'Escape') close();
    });

    // Hydrate step 1 from saved profile
    var ftEl = modal.querySelector('[data-ec-fms-height-ft]');
    var inEl = modal.querySelector('[data-ec-fms-height-in]');
    var lbEl = modal.querySelector('[data-ec-fms-weight]');
    if (inputs.ft != null) ftEl.value = inputs.ft;
    if (inputs.in != null) inEl.value = inputs.in;
    if (inputs.lbs != null) lbEl.value = inputs.lbs;
    ftEl.addEventListener('input', function () { inputs.ft = parseInt(ftEl.value, 10) || 0; });
    inEl.addEventListener('input', function () { inputs.in = parseInt(inEl.value, 10) || 0; });
    lbEl.addEventListener('input', function () { inputs.lbs = parseInt(lbEl.value, 10) || 0; });

    // Hydrate step 2 chips
    ['belly', 'hips', 'bust'].forEach(function (group) {
      var container = modal.querySelector('[data-ec-fms-group="' + group + '"]');
      if (!container) return;
      container.querySelectorAll('.ec-fms__chip').forEach(function (chip) {
        if (chip.getAttribute('data-value') === inputs[group]) {
          chip.classList.add('ec-fms__chip--selected');
        } else {
          chip.classList.remove('ec-fms__chip--selected');
        }
        chip.addEventListener('click', function () {
          inputs[group] = chip.getAttribute('data-value');
          container.querySelectorAll('.ec-fms__chip').forEach(function (c) {
            c.classList.toggle('ec-fms__chip--selected', c === chip);
          });
        });
      });
    });

    // Hydrate step 3 slider
    var fitEl = modal.querySelector('[data-ec-fms-fit]');
    fitEl.value = inputs.fit;
    fitEl.addEventListener('input', function () { inputs.fit = parseInt(fitEl.value, 10) || 0; });

    nextBtn.addEventListener('click', handleNext);
    backBtn.addEventListener('click', handleBack);
    ctaBtn.addEventListener('click', applySelection);

    function open() {
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      goToStep(saved ? 4 : 1, saved ? true : false);
    }
    function close() {
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }

    function validateStep() {
      if (state.step === 1) {
        return inputs.ft && inputs.ft >= 3 && inputs.lbs && inputs.lbs >= 70;
      }
      return true;
    }

    function handleNext() {
      if (!validateStep()) {
        nextBtn.animate(
          [{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }],
          { duration: 240 }
        );
        return;
      }
      if (state.step < TOTAL_STEPS - 1) {
        goToStep(state.step + 1);
      } else if (state.step === TOTAL_STEPS - 1) {
        computeAndShowResult();
      }
    }

    function handleBack() {
      if (state.step > 1) goToStep(state.step - 1);
    }

    function computeAndShowResult() {
      saveProfile(inputs);
      state.result = recommendSize(inputs, sizes);
      if (!state.result) return;
      renderResult();
      goToStep(4);
    }

    function renderResult() {
      if (!state.result) return;
      modal.querySelector('[data-ec-fms-result-size]').textContent = state.result.size;
      ctaBtn.textContent = 'Add ' + state.result.size + ' to Cart';
    }

    function goToStep(n, skipCompute) {
      state.step = n;
      steps.forEach(function (s) {
        var step = parseInt(s.getAttribute('data-ec-fms-step'), 10);
        s.toggleAttribute('hidden', step !== n);
      });
      progressEls.forEach(function (p) {
        var step = parseInt(p.getAttribute('data-step'), 10);
        p.classList.toggle('is-active', step <= n);
      });
      backBtn.toggleAttribute('hidden', n === 1);
      if (n === TOTAL_STEPS) {
        nextBtn.setAttribute('hidden', '');
        ctaBtn.removeAttribute('hidden');
        titleEl.textContent = 'Your best fit';
        if (!skipCompute && !state.result) computeAndShowResult();
        if (skipCompute) {
          state.result = recommendSize(inputs, sizes);
          renderResult();
        }
      } else {
        ctaBtn.setAttribute('hidden', '');
        nextBtn.removeAttribute('hidden');
        nextBtn.textContent = n === TOTAL_STEPS - 1 ? 'See my size' : 'Continue';
        titleEl.textContent = n === 1 ? 'Let\u2019s find your size' : n === 2 ? 'Your shape' : 'Your fit preference';
      }
    }

    function applySelection() {
      if (!state.result) return;
      var targetSize = state.result.size;

      // 1) Select the size variant in the picker
      selectSize(targetSize);

      // 2) Give variant-change handlers a tick, then submit the product form
      setTimeout(function () {
        var form = document.getElementById(productFormId);
        var addBtn = form ? form.querySelector('button[name="add"], button[type="submit"][name="add"]') : null;
        if (addBtn && !addBtn.disabled) {
          addBtn.click();
        } else if (form) {
          form.requestSubmit ? form.requestSubmit() : form.submit();
        }
        close();
      }, 60);
    }

    function selectSize(targetSize) {
      var selected = false;
      var radios = document.querySelectorAll(
        'input[type="radio"][name*="Size"], input[type="radio"][name*="size"], input[type="radio"][name*="Maat"], input[type="radio"][name*="maat"]'
      );
      radios.forEach(function (radio) {
        if (selected) return;
        if (normalizeSizeLabel(radio.value) === normalizeSizeLabel(targetSize)) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          selected = true;
        }
      });
      if (!selected) {
        var selects = document.querySelectorAll(
          'select[name*="option"], select.single-option-selector, select[name*="Size"], select[name*="size"]'
        );
        selects.forEach(function (sel) {
          if (selected) return;
          for (var i = 0; i < sel.options.length; i++) {
            if (normalizeSizeLabel(sel.options[i].value) === normalizeSizeLabel(targetSize)) {
              sel.selectedIndex = i;
              sel.dispatchEvent(new Event('change', { bubbles: true }));
              selected = true;
              break;
            }
          }
        });
      }
      return selected;
    }
  }

  function init() {
    document.querySelectorAll('[data-ec-fms-modal]').forEach(initModal);
    placeTrigger();
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(placeTrigger, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
